@if(challengePopup){
<div class="toast-container position-fixed bottom-0 end-0 p-3">
  <div id="liveToast" class="toast glass-effect" role="alert" aria-live="assertive" aria-atomic="true">
    <div class="toast-body">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <img class="profile-picture"
            [src]="challangeData?.sentChallange.image || '/assets/customer-image/men-shadow.png'"
            alt="profile picture" />

          <div>
            <h5 class="mb-0">{{challangeData?.sentChallange}}</h5>
            <div class="d-flex align-items-center">
              <img [src]="gameModeImg" alt="">
              <p class="mb-0">{{challangeData?.time}}</p>
              @if(challangeData?.ratedGame){
              <p class="ms-3 mb-0">rated</p>
              }

            </div>

          </div>
        </div>
        <div>
          <i class="fa-solid fa-check" (click)="accept('true')"></i>
          <i class="fa-solid fa-xmark ms-3" (click)="reject('false')"></i>
        </div>

      </div>
    </div>
  </div>
</div>
}